import React, {
    createContext,
    useContext,
    useEffect,
    useRef,
    useState,
    ReactNode,
} from 'react';

import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';

interface PaymentStatusContextProps {
    paymentMessage: string;
    connectToPaymentStatus: (userId: string) => void;
    disconnect: () => void;
}

const PaymentStatusContext = createContext<PaymentStatusContextProps | undefined>(undefined);

export const PaymentStatusProvider = ({ children }: { children: ReactNode }) => {

    const [paymentMessage, setPaymentMessage] = useState('');

    const stompClientRef = useRef<Client | null>(null);

    const connectToPaymentStatus = (userId: string) => {

        const socket = new SockJS(`${process.env.REACT_APP_WS_BASE_URL}/ws-payment`);
        
        const client = new Client({

            webSocketFactory: () => socket,

            onConnect: () => {
                client.subscribe(`/topic/payment-status/${userId}`, (message) => {
                    setPaymentMessage(message.body);
                    console.log(`🔔 ${message.body}`);
                });
            },

            onStompError: (frame) => {
              console.error('Broker error:', frame);
            },

        });
        
        client.activate();
        stompClientRef.current = client;
    };

    const disconnect = () => {
        stompClientRef.current?.deactivate();
    };

    useEffect(() => {
        return () => disconnect();
    }, []);

    return (
        <PaymentStatusContext.Provider value={{ paymentMessage, connectToPaymentStatus, disconnect }}>
            {children}
        </PaymentStatusContext.Provider>
    );
};

export const usePaymentStatus = () => {
    const context = useContext(PaymentStatusContext);
    if (!context) {
        throw new Error('usePaymentStatus must be used within a PaymentStatusProvider');
    }
    return context;
};
  